import Point from '@arcgis/core/geometry/Point';
import { DEFAULT_MAP_SOURCE } from '@env';
import * as turf from '@turf/turf';

import { EsriMap } from '@lib/geo/esri';
import { FsMap } from '@lib/geo/map/types';

import ScreenPoint = __esri.ScreenPoint;

export class FsScreenPoint {
  get defaultMapSource() {
    return DEFAULT_MAP_SOURCE;
  }

  public screenPoint: ScreenPoint | { x: number; y: number };

  private _googleScreenPoint: google.maps.Point;
  private _point: turf.Feature<turf.Point>;

  constructor(latLng: number[], private readonly map: FsMap) {
    this._point = turf.point(latLng);

    switch (this.defaultMapSource) {
      default:
      case 'google':
        this._handleGooglePoint();
        break;
      case 'esri':
        this._handleEsriPoint();
        break;
    }
  }

  private _handleEsriPoint() {
    const point = new Point({
      longitude: this._point.geometry.coordinates[0],
      latitude: this._point.geometry.coordinates[1],
      spatialReference: { wkid: 4326 },
    });
    this.screenPoint = (this.map as unknown as EsriMap)?.mapView.toScreen(point);
  }

  private _handleGooglePoint() {
    const projection = (this.map.mapInstance as unknown as google.maps.Map).getProjection();
    if (!projection) return;

    const latLng = new google.maps.LatLng({
      lng: this._point.geometry.coordinates[0],
      lat: this._point.geometry.coordinates[1],
    });
    this._googleScreenPoint = projection.fromLatLngToPoint(latLng);

    const scale = Math.pow(2, this.map.getZoom());
    const mapBounds = this.map.getBounds();
    const topRight = projection.fromLatLngToPoint(mapBounds.getNorthEast().toLatLngLiteral());
    const bottomLeft = projection.fromLatLngToPoint(mapBounds.getSouthWest().toLatLngLiteral());
    this.screenPoint = {
      x: (this._googleScreenPoint.x - bottomLeft.x) * scale,
      y: (this._googleScreenPoint.y - topRight.y) * scale,
    };
  }
}
